export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9737.f0fdc43e.jpg";